import type {
    IndustryNodeDto,
    IndustryTaxonomyIndex,
} from "app/pages/sales-intelligence/domain/industry/types/taxonomy";
import { indexTree } from "app/pages/sales-intelligence/utils/taxonomy-tree/tree";

/**
 * Indexes the served facet tree. It is taken from the response rather than the taxonomy endpoint because
 * it is already scoped to the industries present in the current results, and already narrowed to the
 * picked branch once a filter is applied.
 *
 * The leaf counts `indexTree` derives structurally are dropped: this list exists to pick an industry to
 * filter by, and a number beside each row reads as a competitor count, which that number is not.
 */
export const toCompetitorIndustryIndex = (nodes: readonly IndustryNodeDto[]): IndustryTaxonomyIndex => ({
    ...indexTree(nodes),
    countById: new Map(),
});
